var cannotLoadAjax = "Can not process your request";

$(document).ready(function () {
   var innovaApiUrl = $("#InnovaApiUrl").val();
   var innovaApiKey = $("#InnovaKey").val();
   var sku = $("#faqTool").val();
    if(sku != null && sku != undefined && sku != ""){
      var url = innovaApiUrl + "/products/" + sku +"/faqs/?r=" + Math.random();
      $.ajax({
          type: "GET",
          crossOrigin: true,
          url: url,
          beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
          },
          error: function (request, status, error) {
            if(request.status != 0){
              alert(cannotLoadAjax);
            }
          },
          success: function (result) {
            if(result.message.success)
              $("#faqsResult").html(result.data);
            if(result.totalQna > 0){
              $("#faqsContent").show();  
              $("#shopify-section-product-faqs").show();              
            }else{
              $("#faqsContent").hide();            
              $("#shopify-section-product-faqs").hide();  
            }
          }
      });    
    }
});

